import {getExplain,getParagraph,getParagraphForEdit,replaceCommonJsonToTag} from '../../../utils/createRender'

let reverseParseText = (data) => {
    let obj = createRender(data,0);
    let stem = {};
    let style = {};
    Object.keys(obj).forEach(v => {
        if (v.indexOf('paragraph') > -1) {
            /*处理段落部分*/
            stem[v] = obj[v];
        }else if(v.indexOf("style") > -1) {
            /*处理段落样式*/
            style = JSON.parse(obj[v]);
        }
    });
    return {
        stem,
        ...obj, // obj里面有样式（style）
        style
    }
}

let reverseParseTextView = data => {
    let obj = createRender(data,1);
    let stem = "";
    Object.keys(obj).forEach(val => {
        if (val.indexOf("paragraph") > -1) {
            // 题干部分
            if(obj[val].indexOf('inner_audio')>-1){
                let reading = obj[val].match(/<div style="margin-bottom: 10px"><div class="inner_audio"}><\/div><span>点击读题<\/span><audio class="math_reading" src=".*?"><\/audio><\/div>/g);
                let audio = reading[0]?reading[0]:''
                stem = audio + stem + obj[val].replace(audio,'');
            }else{
                stem += obj[val];
            }
        }
    })

    let result = {
        stem,
        ...obj
    };
    return result
}
function createRender(data,showType = 1) {//showType:0 编辑用，1 展示用
    if(!data.stem){
        return {}
    }
    // 把题干和挖空分开
    let stem = data.stem, imgObj = {};
    let reg = /#{"type":"para_begin","style":"math_fill_image"}##(.*)##{"type":"para_end"}#/;
    let BlankResult = reg.exec(stem);
    let imgResult = BlankResult[0];
    stem = stem.split(imgResult)[0];
    imgObj = JSON.parse(BlankResult[1]);
    let imgWidth = /(\d)*/.exec(imgObj.width)[0];
    let imgHeight = /(\d)*/.exec(imgObj.height)[0];
    let imgInitWidth = /(\d)*/.exec(imgObj.imgInitWidth)[0];
    let imgInitHeight = /(\d)*/.exec(imgObj.imgInitHeight)[0];
    let imgDetail = {
        imgUrl: imgObj.src,
        imgWidth,
        imgHeight,
        imgInitWidth,
        imgInitHeight,
        
    }
    imgDetail.imgInitWidth=imgInitWidth?imgInitWidth:imgWidth
    imgDetail.imgInitHeight=imgInitHeight?imgInitHeight:imgHeight

    let blanklist = [], newBlankList = imgObj.blanklist;
    newBlankList.forEach(item => {
        let data = {
            x_pos: parseInt(item.x_pos/100*imgDetail.imgInitWidth),
            y_pos: parseInt(item.y_pos/100*imgDetail.imgInitHeight),
            size:item.size,
            value: item.value ? item.value : item.answer
        }
        if (item.answer) {
            data = Object.assign(data, {
                lock: false,
            })
        }
        else {
            data = Object.assign(data, {
                lock: true,
            }) 
        }
        blanklist.push(data)
    });
    let render = {};
    // 匹配answer
    let answer = getAnswer(data.answer);
    switch (showType){
        case 0:
            // 匹配 stem
            var {paragraph,style} = getParagraphForEdit(stem,'paragraph');
            render = Object.assign({}, paragraph, answer, style, {imgDetail, blanklist});
            break;
        case 1:
            // 匹配 stem
            var {paragraph,style} = getParagraph(stem,'paragraph');
            render = Object.assign({}, paragraph, answer, style, {imgDetail, blanklist});
            break;
        default:
            break;
    }
    return render;
}

function ruleImgReverse(num) {
    return `<img class="blank_img_${num}" style="width: 38px; height: 20px" src="static/img/empty/empty_${num}.png"/>`;
}


function getAnswer(str){
    let answerObj = !!str ? JSON.parse(str) : {};
    let ruleList = [], ruleContent = [], fillableValue = [], ruleDisplay = [];
    if (answerObj.numbers) {
        answerObj.numbers.forEach(item => {
            fillableValue.push(item.value)
        })
    }
    if (answerObj.answer) {
        let answer = [...answerObj.answer];
        for (let i = 0; i < answer.length; i++) {
            ruleList.push({
                value: answer[i].result,
            });
            let ruleStr = '', ruleDisplayStr = '';
            answer[i].groups.forEach((item, index) => {
                let rules = item.rules;
                rules.forEach((innerItem, i) => {
                    ruleStr = ruleStr + ((!innerItem.op && index != 0) ? '=' : innerItem.op) + ruleImgReverse(innerItem.blank);
                    ruleDisplayStr = ruleDisplayStr + ((!innerItem.op && index != 0) ? ' = ' : (!innerItem.op ? innerItem.op : (' ' +innerItem.op + ' '))) + `空${innerItem.blank}`;
                });
            });
            ruleContent.push(`<p>${ruleStr}</p>`);
            ruleDisplay.push(ruleDisplayStr);
        }
    }

    return {
        ruleList,
        ruleContent,
        ruleDisplay,
        fillableValue
    };
}
export {reverseParseText,reverseParseTextView}


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/numMatrix/createRender.js